export interface SearchResultItem {
    category: string;
    keyword: string;
    label: string;
    type: string | null;
}

export interface SearchResult {
    item: SearchResultItem;
    score: number;
}

export class CategorySearchService {
    async search(keyword: string, locale: string): Promise<SearchResult[]> {
        const encodedKeyword = encodeURIComponent(keyword);
        const response = await fetch(`/category-search/${locale}/${encodedKeyword}`);
        const data = await response.json();
        return data.matches;
    }
}
